import {t} from '../../../common/getTranslations';
import {getFormattedNumberWithSuffix} from '../../../common/shared/utils/getFormattedNumberWithSuffix';
import {stopPropagationEvent} from '../../../common/shared/utils/stopPropagationEvent.function';
import {twMerge} from '../../../common/twMerge';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {ViewerEndStarCommentProps} from './ViewerEndStarCommentProps.interface';

export function ViewerEndStarComment({
  ratingCount,
  ratingSum,
  commentCount,
  isMobile,
  onClickStar,
  onClickComment,
  ...props
}: ViewerEndStarCommentProps) {
  return (
    <div {...props}>
      <div className={twMerge('flex justify-between', !isMobile && 'h-30pxr')}>
        <div
          className="flex items-center"
          onClick={e => {
            stopPropagationEvent(e);
            onClickStar(e);
          }}
        >
          <Icon type={IconType.ViewerEndStar} disableActiveEffect />
          <Text className="font-medium2-bold ml-8pxr text-theme-solid-100">
            {(ratingCount === 0 ? 0 : ratingSum / ratingCount).toFixed(1)}
          </Text>
          <Text
            className="font-medium2 ml-8pxr text-theme-solid-40"
            data-testid="viewer-rating"
          >
            {ratingCount !== 0 &&
              t('viewer_end_rating_num', {
                values: {
                  value: getFormattedNumberWithSuffix(ratingCount),
                },
              })}
          </Text>
        </div>
        <div
          className={twMerge(
            'relative z-10 flex shrink-0 cursor-pointer items-center',
            isMobile && 'py-9pxr pl-16pxr',
            !isMobile && 'ml-16pxr'
          )}
          onClick={e => {
            stopPropagationEvent(e);
            onClickStar(e);
          }}
        >
          <Text className="font-small1 mr-2pxr text-theme-solid-100">
            {t('viewer_end_rating')}
          </Text>
          <Icon type={IconType.ButtonArrowRight} disableActiveEffect />
        </div>
      </div>
      <div
        className={twMerge(
          'flex justify-between',
          !isMobile && 'mt-12pxr h-30pxr'
        )}
      >
        <div className="flex items-center space-x-8pxr">
          <div
            className="flex items-center space-x-8pxr"
            onClick={e => {
              stopPropagationEvent(e);
              onClickComment(e);
            }}
          >
            <Icon type={IconType.ViewerEndComment} disableActiveEffect />
            <Text
              className={twMerge(
                'text-theme-solid-100',
                commentCount === 0 ? 'font-medium2' : 'font-medium2-bold'
              )}
            >
              {commentCount === 0
                ? t('viewer_end_comment_blank')
                : getFormattedNumberWithSuffix(commentCount)}
            </Text>
          </div>
        </div>
        <div
          className={twMerge(
            'relative z-10 flex shrink-0 cursor-pointer items-center',
            isMobile && 'py-9pxr pl-16pxr',
            !isMobile && 'ml-16pxr'
          )}
          onClick={e => {
            stopPropagationEvent(e);
            onClickComment(e);
          }}
        >
          <Text className="font-small1 mr-2pxr text-theme-solid-100">
            {t('comment_accessibility_content')}
          </Text>
          <Icon type={IconType.ButtonArrowRight} disableActiveEffect />
        </div>
      </div>
    </div>
  );
}
